import styled from '@emotion/styled';

const Technologies = styled.div`
  display: flex;
  margin: 20px 0;
`;

export default Technologies;
